import { createSlice } from "@reduxjs/toolkit";

export interface ApplicantInformationInterface {
  entityName: string;
  ein: string;
  contactPersonName: string;
  contactPersonEmail: string;
  streetAddress: string;
  city: string;
  state: string;
  zipCode: number | null;
  phone: number | null;
  website: string;
  formationDate: string;
  fullTimeEmployeeCount: number | null;
  anyApply: string[];
  applicantInfoIsValid: boolean;
}

const initialState: ApplicantInformationInterface = {
  entityName: "",
  ein: "",
  contactPersonName: "",
  contactPersonEmail: "",
  streetAddress: "",
  city: "",
  state: "Select",
  zipCode: null,
  phone: null,
  website: "",
  formationDate: "",
  fullTimeEmployeeCount: null,
  anyApply: [],
  applicantInfoIsValid: false,
};

export const applicantInformationSlice = createSlice({
  name: "applicantInformation",
  initialState,
  reducers: {
    clearApplicantInfo: (state) => initialState,
    setApplicantInformation(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    setApplicantInfoIsValid(state, { payload }) {
      return {
        ...state,
        applicantInfoIsValid: payload,
      };
    },
  },
});

export const {
  setApplicantInformation,
  setApplicantInfoIsValid,
  clearApplicantInfo,
} = applicantInformationSlice.actions;
export default applicantInformationSlice.reducer;
